import type { SimpleBoard } from "./levelgenerator/simpleBoard";
import { serializeXY } from "./serialization";
import { Thing } from "./thing";
import type { XY } from "./xy";
import { ZOrder } from "./zOrder";

export class PhysicalThing extends Thing {
	xy: XY;
	visualId: number;
	blocksMovement: boolean;
	constructor(xy: XY, blocksMovement: boolean = false) {
		super();
		this.xy = xy;
		this.visualId = Math.floor(Math.random() * 840);
		this.blocksMovement = blocksMovement;
	}

	getZOrder(): number {
		return ZOrder.TILE;
	}

	isVisible(): boolean {
		return true;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	// Whether gas can occupy this thing's tile even when the tile is impassable
	// (e.g. fences, chasms, cracked shells). See isGasPassable() in baseGas.ts.
	isGasPermeable(): boolean {
		return false;
	}

	// Purely visual projections (aim indicators, light beams) return false —
	// they have no physical presence and can't be destroyed or consumed.
	isTangible(): boolean {
		return true;
	}

	// While a MovementEffect is animating this thing, the renderer normally pins
	// its sort row at max(origin.y, destination.y) so it draws on top of things
	// in either row. Override to true if the thing should instead sort at the
	// topmost (smallest-y) row touched by the move — useful for entities that
	// retract into a higher-z-order northern neighbor (e.g. a sliding door
	// retracting into a wall) and need to stay behind that neighbor for the
	// entire slide animation, both opening and closing.
	usesMinSortYWhileMoving(): boolean {
		return false;
	}

	static initOnBoard(xy: XY, board: SimpleBoard, _props?: Record<string, unknown>): PhysicalThing[] {
		const thing = new (this as unknown as { new (xy: XY): PhysicalThing })(xy);
		board.putThing(thing);
		return [thing];
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			xy: serializeXY(this.xy),
			visualId: this.visualId,
			blocksMovement: this.blocksMovement,
		};
	}
}
